import { createSlice } from "@reduxjs/toolkit";
import { Notification, NotificationType } from "../../types/slices/notificationType";
import { ApiStatus } from "../../types/api/status";

const initialState: NotificationType =
{
    status: ApiStatus.FETCHED,
    notifications: [],
    notificationSelected: {} as Notification,
    errorMessage: undefined,
}

const notificationSlice = createSlice({
    name: 'notificationSlice',
    initialState,
    reducers:{
    onSetNotifications (state, {payload}: {payload: any}) {
        state.status        = ApiStatus.FETCHED
        state.notifications = payload
        state.errorMessage  = undefined
    },
    changeStatus (state, { payload }: { payload: ApiStatus}){
        state.status = payload
    }
  }
})

export const { onSetNotifications, changeStatus } = notificationSlice.actions;
export const selectNotification = (state:any) => state.notificationSlice;
export default notificationSlice.reducer;